export default class CategoryAddController {
  constructor(ImagesDataProvider, $state, $timeout, API_URL) {
    "ngInject"
    this.category = {};
    this.ImagesDataProvider = ImagesDataProvider;
    this.$state = $state;
    this.$timeout = $timeout;
    this.API_URL = API_URL;
    this.errorShow = 0;
  }

onvertToSlug(text) {
  return text
    .toString()
    .normalize('NFKD')                // Bryt ner bokstäver med diakritiska tecken
    .replace(/[\u0300-\u036f]/g, '')  // Ta bort diakritiska tecken (accents)
    .toLowerCase()
    .replace(/å/g, 'a')
    .replace(/ä/g, 'a')
    .replace(/ö/g, 'o')
    .replace(/æ/g, 'ae')
    .replace(/ø/g, 'oe')
    .replace(/\u00fc/g, 'ue')
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}

  create(form) {
    if (!form) {
      return false;
    }
    let
      vm = this;
    vm.category.slug = vm.onvertToSlug(vm.category.name);
    vm.ImagesDataProvider.saveCategory(vm.category).then(function (res) {
      if (res.exist == '1') {
        vm.existRecord = 1;
      }
      else {
        vm.$state.go('app.imageCategories');
      }
    })

  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/images/components/category_add/controller.js
 **/